import VueRouter from 'vue-router';

import ProductShare from './pages/productShare.vue';
import IdentityMaterials from './pages/identityMaterials.vue';
import MaterialTemplate from './pages/materialTemplate.vue';
import Interview from './pages/embassy-notice/index.vue';
import InterviewMaterial from './pages/interviewMaterial.vue';

import InviteInApp from './pages/inviteInApp.vue';
import Invite from './pages/invite.vue';
import InviteRule from './pages/inviteRule.vue';
import Register from './pages/register.vue';
import RegisterSuccess from './pages/registerSuccess.vue';
import Policy from './pages/policy.vue';
import privacyPolicy from './pages/privacyPolicy.vue';
import CommonCoupon from './pages/commonCoupon.vue';
import CompanyCoupon from './pages/companyCoupon.vue';
import CouponUsage from './pages/couponUsage.vue';
import Balance from './pages/balance.vue';
import MoneyUsage from './pages/moneyUsage.vue';
import Process from './pages/process.vue';
import InsuranceDetail from './pages/insuranceDetail.vue';
import ClaimsProcess from './pages/claimsProcess.vue';
import ApplicantsDeclare from './pages/applicantsDeclare.vue';
import Feedback from './pages/feedback.vue';
import QAndADetial from './pages/qAndADetial.vue';
import RefundExplain from './pages/refundExplain.vue';
import randomWord from './pages/randomWord.vue';
import idspProtocol from './pages/idspProtocol.vue';
import Activity from './pages/activity/activity.vue';
import Activity404 from './pages/activity/activity-404.vue';
import pandaServiceFeatures from './pages/pandaServiceFeatures.vue';
import orderHandleFlow from './pages/orderHandleFlow.vue';
import share404 from './pages/share-404.vue';
import knowPdv from './pages/knowPdv.vue';
import qiyuClueList from './pages/qiyu-service/clue-list';

import WorkWXCustomer from './pages/work-wx/customer';
import bindCustomerAccount from './pages/work-wx/customer/bind-customer-account';
import WorkWxCountry from './pages/work-wx/country';
import WorkWXCustomerBehaviorList from './pages/work-wx/customer/customer-behavior-list/customer-behavior-list';
import WorkBench from './pages/work-wx/workbench/WorkBench.vue';
import FileTemplateList from './pages/work-wx/file-template-list/FileTemplateList.vue';

import earliestDate from './pages/earliest-date/earliest-date.vue';

export const routes = [
  { path: '/productShare', name: 'productShare', component: ProductShare },
  {
    path: '/identityMaterials',
    name: 'identityMaterials',
    component: IdentityMaterials,
  },
  {
    path: '/materialTemplate',
    name: 'materialTemplate',
    component: MaterialTemplate,
  },
  { path: '/interview', name: 'interview', component: Interview },
  {
    path: '/interview/material/:orderId/:applicantId',
    name: 'InterviewMaterial',
    component: InterviewMaterial,
  },
  { path: '/inviteInApp', name: 'inviteInApp', component: InviteInApp },
  { path: '/invite', name: 'invite', component: Invite },
  { path: '/invite-rule', name: 'inviteRule', component: InviteRule },
  {
    path: '/register/:userId/:mobilePhone',
    name: 'register',
    component: Register,
  },
  {
    path: '/register-success',
    name: 'registerSuccess',
    component: RegisterSuccess,
  },
  { path: '/policy', name: 'policy', component: Policy },
  { path: '/privacyPolicy', name: 'privacyPolicy', component: privacyPolicy },
  { path: '/common-coupon', name: 'commonCoupon', component: CommonCoupon },
  { path: '/company-coupon', name: 'companyCoupon', component: CompanyCoupon },
  { path: '/couponUsage', name: 'couponUsage', component: CouponUsage },
  { path: '/balance', name: 'balance', component: Balance },
  { path: '/moneyUsage', name: 'moneyUsage', component: MoneyUsage },
  { path: '/process', name: 'process', component: Process },
  { path: '/insurance', name: 'insurance', component: InsuranceDetail },
  { path: '/claimsProcess', name: 'claimsProcess', component: ClaimsProcess },
  {
    path: '/applicantsDeclare',
    name: 'applicantsDeclare',
    component: ApplicantsDeclare,
  },
  { path: '/advice', name: 'feedback', component: Feedback }, // app使用的优化建议反馈
  { path: '/qAndADetial', name: 'qAndADetial', component: QAndADetial },
  { path: '/refundExplain', name: 'refundExplain', component: RefundExplain },
  { path: '/randomWord', name: 'randomWord', component: randomWord },
  { path: '/idsp-protocol', name: 'idspProtocol', component: idspProtocol },
  { path: '/activity/:activitySuffix', name: 'Activity', component: Activity },
  { path: '/activity-404', name: 'Activity404', component: Activity404 },
  {
    path: '/pandaServiceFeatures',
    name: 'pandaServiceFeatures',
    component: pandaServiceFeatures,
  },
  {
    path: '/orderHandleFlow',
    name: 'orderHandleFlow',
    component: orderHandleFlow,
  },
  { path: '/share-404', name: 'share404', component: share404 },
  { path: '/know-pdv', name: 'knowPdv', component: knowPdv },
  { path: '/qiyu/clue-list', name: 'qiyuClueList', component: qiyuClueList },
  { path: '/earliest-date', name: 'earliestDate', component: earliestDate },

  // 保留一段时间后删除
  {
    path: '/company-invite',
    name: 'companyInvite',
    redirect: { name: 'companyCoupon' },
  },

  // 企业微信部分
  {
    path: '/work-wx/customer',
    name: 'WorkWXCustomer',
    component: WorkWXCustomer,
  }, // PDV客户
  {
    path: '/work-wx/bind-customer-account',
    name: 'bindCustomerAccount',
    component: bindCustomerAccount,
  }, // PDV客户-更换绑定账号
  {
    path: '/work-wx/customer/behavior-list',
    name: 'WorkWXCustomerBehaviorList',
    component: WorkWXCustomerBehaviorList,
  }, // 查看客户行为
  { path: '/work-wx/country', name: 'WorkWxCountry', component: WorkWxCountry }, // PDV商品
  { path: '/work-wx/workbench', name: 'WorkBench', component: WorkBench },
  {
    path: '/work-wx/file-template-list',
    name: 'FileTemplateList',
    component: FileTemplateList,
  },
];

const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return {
      x: 0,
      y: 0,
    };
  },
});
export default router;
